var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLearningCoach(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26618 5.33008C4.51852 5.33008 1.48047 8.36813 1.48047 12.1158C1.48047 15.8634 4.51852 18.9015 8.26618 18.9015C12.0138 18.9015 15.0519 15.8634 15.0519 12.1158L22.9559 10.3063V5.33008H15.6274V7.1396H14.7226C13.7233 7.1396 12.9131 6.32943 12.9131 5.33008H8.26618Z",
    stroke: "white",
    strokeWidth: 1.93016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26432 15.2826C10.0132 15.2826 11.431 13.8648 11.431 12.1159C11.431 10.367 10.0132 8.94922 8.26432 8.94922C6.51542 8.94922 5.09766 10.367 5.09766 12.1159C5.09766 13.8648 6.51542 15.2826 8.26432 15.2826Z",
    stroke: "white",
    strokeWidth: 1.93016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2422 5.33008V10.9349",
    stroke: "white",
    strokeWidth: 1.93016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52715 6.45554L3.46912 5.39751C2.93911 4.8675 2.07982 4.8675 1.54985 5.39751C1.01984 5.92752 1.01984 6.78677 1.54985 7.31678L2.60788 8.37481",
    stroke: "white",
    strokeWidth: 1.93016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLearningCoach);
export default __webpack_public_path__ + "static/media/icon-learning-coach.3841758723a3cb5e0d4def573ed2ea2b.svg";
export { ForwardRef as ReactComponent };